import API from "shared/services/Api";
import { IPrescription } from "shared/types/Prescription";

export const sendPrescription = async (data: IPrescription, userId: string) =>
  API.post(`oc/referrals/prescription?id=${userId}`, data);
